enum JiraProject {
  TROUBLESHOOT = 'troubleshoot',
  BUG_REPORT = 'bug_report'
}

export default JiraProject
